"use client";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";
import { X } from "lucide-react";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            className="rounded-[12px] border-0 bg-[#0A0A0A] px-[30px] py-[15px] text-white"
          >
            <div className="flex-start gap-5">
              {/* <div className="rounded-full bg-[#b5272c] p-2">
                <div className="flex items-center justify-center gap-2.5 rounded-[100px] bg-white p-1.5">
                  <X className="h-2.5 w-2.5 text-black" />
                </div>
              </div> */}
              <div className="grid gap-1">
                {title && (
                  <ToastTitle className="text-[#E94F54]">{title}</ToastTitle>
                )}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
